<template>
	<div>
		<breadcrumb :routerList="[{to:'/contract-list',title:'合同管理'},{title:'新建线下合同'}]"/>
		<div class="h-content" :class="{'ljjtips':true}">
			<div class="h-piece">
				<div class="h-formLine weekplandetail23" v-show="tabIndex == '1'">
                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                        <h1>合同详情</h1>
                    </div>
					<el-form label-position="right" :model="formInline"  ref="form4" :rules="rules" :inline="true"  class="demo-ruleForm h-formbLine">
						<el-form-item label="合同编码" class="h-elformWrap-2" prop="id">
						<el-input v-model="formInline.id" placeholder="请输入合同名称" :disabled="true"></el-input>
					  </el-form-item>
                        <el-form-item label="合同名称" class="h-elformWrap-2">
                            <el-input readonly v-model="formInline.contractName"></el-input>
                        </el-form-item>
                    <el-form-item :label="customerlabel" class="h-elformWrap-2" prop="customerName">
                      <el-input v-model="formInline.customerName" @change="fillCusCode" :disabled="true" placeholder="请输入经销商名称"></el-input>
                    </el-form-item>

                        <el-form-item label="销售省区" class="h-elformWrap-2 w-elformWrap" prop="saleareaCode">
                            <brselect category="YlSalesArea_chanpin" :v="formInline.saleareaCode"
                                      v-model="formInline.saleareaCode" :disabled="disabled"></brselect>
                        </el-form-item>
                        <el-form-item label="销售地市" class="h-elformWrap-2 w-elformWrap" prop="salesCity" >
                            <el-select :multiple="true"
                                       :clearable="true"
                                       v-model="formInline.salesCity"
                                       @change="getCityChange"
                                       :disabled="disabled"
                                       :v="formInline.salesCity">
                                <el-option v-for="item in salesCity"
                                           :key="item.index"
                                           :value="item.code"
                                           :label="item.name"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="质保期(月)" class="h-elformWrap-2" prop="contractAmount" >
                            <el-input v-model.number="formInline.guaranteeTime" :disabled="disabled"  placeholder="请输入数字"></el-input>
                        </el-form-item>
                        <el-form-item label="合同金额(元)" class="h-elformWrap-2 h-moneyIcon" prop="contractAmount">
                            <el-input v-model.number="formInline.contractAmount" :disabled="disabled"  placeholder="请输入数字"></el-input>
                        </el-form-item>
                        <el-form-item label="回款模式" class="h-elformWrap-2" prop="contractAmount">
                            <el-input v-model="formInline.rentPlace" :disabled="disabled"  type="text"></el-input>
                        </el-form-item>

                        <el-form-item label="合同附件" class="h-elformWrap-1 h-formRbtnOut h-formRbtnOut2" style="width: 100%;" prop="name">
                            <brupload :refid="this.contractId" reftype="合同附件" :uploadflag="!disabled" :delflag="!disabled"
                                      :tpFlag = 'true' :isTpAndPdf = 'true'
                            ></brupload>
                        </el-form-item>

                 </el-form>
        </div>
		  </div>
      <div class="bannerBox2" v-if="0 == $route.query.taskstatus">
        <div class="h-row h-mrt1">
          <div class="h-rowIn">
            <div class="h-rowBox">
              <div class="h-rowCon">
                <div class="h-pieceIn2">
                  <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                    <h1>审核信息</h1>
                  </div>
                  <div class="h-pieceCon2 ">
                    <div class="h-formLine weekplandetail11" style="position: relative;">
                      <el-form :inline="true" :model="formInline">
                        <el-form-item label="审批意见" class="h-elformWrap-2 newBox"
                                      style="width: 100%!important;">
                          <el-input
                              v-model="formInline.auditMind2"
                              placeholder="请输入"></el-input>
                        </el-form-item>
                      </el-form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    <div style="text-align: center;margin-top: 0.3rem">
        <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">返回</el-button>
        <el-button class="h-btn h-bBtn h-bgred"
                   @click="contractPass(2)" v-if="0 == $route.query.taskstatus">驳回
        </el-button>
        <el-button class="h-btn h-bBtn h-bggreen" v-if="0 == $route.query.taskstatus" @click="contractPass(1)">通过
        </el-button>

        <el-button class="h-btn h-bBtn h-bggreen" @click="submitHHxm('1')" v-if="!disabled && '0' != formInline.status">暂存</el-button>
        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="submitHHxm('0')"  v-if="!disabled">确认提交</el-button>

      <el-button class="h-btn h-bBtn" @click="viewpress" v-if="disabled">
        审批跟踪
      </el-button>
    </div>
    <viewhistory :visible.sync="showhistory" v-if="showhistory"
                 :id="instid"/>
    </div>

	</div>
</template>

<script>
	import big from 'big.js';
	import ss from "../../../api/SystemService";
	import util from "../../../utils/util";
    export default {
        name:'leftMenu',
        data() {
            return {
				// 新手引导页
				toshow:"contract-agent.vue",
				checked:true,
				status:1,
				showOrhide:false,
        contractId:null,
        guanlianxiangmFlag:true,

        optionsProduct2_jzx:[],
				optionsProduct2:[],
				optionsProduct1:[],
        lianqunList:[],
        qudao:[],
				customerlabel:"客户名称",
				allProjectByUser:[],
				tempProject:[],
				tempProject2:[],
                tableData2:[],
                tableData3:[],
                contarctAddList:[{
                    id:null,
                    contractId:null,
                    type:null,
                    starttime:null,
                    endtime:null,
                    status:null,
                    instid:null,
                    refid:this.$util.getUuid(),
                }],
                contarctAdd:{
                    id:null,
                    contractId:null,
                    saleareaCode:null,
                    type:null,
                    starttime:null,
                    endtime:null,
                    status:null,
                    instid:null,
                    refid:null,
                    contarctAddLists:[],
                },
				zlflag:false,
				bzflag:false,
				dlsflag:false,
                uploaddownexcelflag:false,
                showhistory:false,
				pickerOptions1:{
					disabledDate: (time)=>{
						if (this.formInline.contractEndtime != "") {
							return time.getTime() > this.formInline.contractEndtime;
						}
					}
				},
                q2:{
                    pageSize:10,
                    pageNo:1,
                    total:0,
                    contractId:null,
                    customerName:null
                },
                q3:{
                    pageSize:10,
                    pageNo:1,
                    total:0,
                    contractId:null,
                    agentNameLike:null,
                    year: 2024,
                },
				pickerOptions2:{
					disabledDate: (time)=>{
						if (this.formInline.contractStarttime != "") {
							return time.getTime() < this.formInline.contractStarttime;
						}
					}
				},
				//表单
				formInline:{
            zltype:"",
            contractName:null,
            pid:"",
            customerCode:"",
            salechannelCode:null,
            contractCatecory:"CT-DLS-KJ",
            contractAmount:"",
            contractStatus:"",
            contractStarttime:"",
            contractEndtime:"",
            contractCashPledge:"",
            productCode:"",
            productName:"",
            productPrice:"",
            productType:"",
            rentNum:"",
            rentTime:"",
            guaranteeTime:"",
            productList:[],
            zsyzq:"",
            rentType:"",
            isShhm:0,
            isJj:0,
            rentPlace:"",
            returnPlace:"",
            rentPrice:"",
            contractAgent:"",
            auditMind2:"",
            status:"",
            isZc:"",
            saleareaCode:null,
            bscContractAgentAddList:[],
            salesCity:"",
				},
				formInline1:{
					wuliufangshi:2,
					condition:[]
				},
				customerList: [],
				//多选
				checkList:[],
				fileList:[],
        salesCity:[],
        channels:null,
        chakan:false,
        isCt:false,
				file:{
                    name:''
                },
				rules:{
					contractName: [
						{ required: true, message: '请输入合同名称', trigger: 'blur' },
					],
					contractCatecory: [
						{ required: true, message: '请选择合同类型', trigger: 'change' },
					],
                    contractAmount: [
                        { required: true, message: '请输入金额', trigger: 'blur' },
                        { type : 'number', message:"必须为数字值"}
                    ],
                    guaranteeTime: [
                        { required: true, message: '请输入质保期', trigger: 'blur' },
                        { type : 'number', message:"必须为数字值"}
                    ],
                    rentPlace: [
                        { required: true, message: '请输入回款模式', trigger: 'blur' },
                    ],
                    saleareaCode: [
                        { required: true, message: '请选择销售省区', trigger: 'change' },
                    ],
                    salesCity: [
                        { required: true, message: '请选择销售地市', trigger: 'change' },
                    ],
				},
				jzxFlag:false,
				rentTimeList:[],
                contractSonList:[],
        taskid:null,
        Instid:null,
                isXy:null,
                tabIndex:null,
        disabled:false,
              fileFlag:true,
              daquflag:false,
              lastflag:false,

      }
    },
      methods: {
        save(){
          this.formInline.editStatus = 0;
          var cond = this.formInline1.condition;
          this.formInline.payCondition = cond.join(",");
          this.formInline.contractType = 0;
          this.formInline.contractStarttime = this.formatDate(this.formInline.contractStarttime);
          this.formInline.contractEndtime = this.formatDate(this.formInline.contractEndtime);
          this.formInline.wuliufangshi = this.formInline1.wuliufangshi;
          if(cate == "CT-ZL" && this.formInline.zltype == '3'){
            var totalMoney = new big(0);
            if(this.formInline.zlList){
              this.formInline.zlList.forEach((obj)=>{
                totalMoney = totalMoney.plus(new big(obj.productTotalPrice));
              })
            }
            this.formInline.contractAmount = totalMoney;
          }
          this.formInline.zlList = this.formInline.zlList;
          ss.contractService.insertAgent(this.formInline).then(rd=>{
            if(rd.f){
              this.$msg.msgs("保存成功！");
              this.$router.push("contract-list");
            }else{
              this.$msg.msgs("保存失败！"+rd.msg);
            }
          });
        },
          viewpress() {
              this.showhistory = true;
          },
        submit(rd){
          var subflag1 = false;
          this.$refs['form1'].validate((valid) => {
            if (valid){
              subflag1=true;
            }else{
              this.$msg.msge("请完善合同信息后再提交！");
              return false;
            }
          });
          if (!subflag1) {
            return;
          }
          console.log("节点",1)
          var cate = this.formInline.contractCatecory;
          this.$msg.confirm("确定要提交吗？",()=>{
            this.formInline.isZc = rd;
            this.formInline.editStatus = 1;
            this.formInline.contractType = 0;
            this.formInline.contractStarttime = this.formatDate(this.formInline.contractStarttime);
            this.formInline.contractEndtime = this.formatDate(this.formInline.contractEndtime);
            this.formInline.wuliufangshi = this.formInline1.wuliufangshi;
            console.log(1211,this.formInline);
              ss.contractService.insertAgent(this.formInline).then(rd=>{
                if(rd.f){
                  this.$msg.msgs("提交成功！");
                  this.$router.push("contract-list");
                }else{
                  this.$msg.msgs("提交失败！"+rd.msg);
                }
              })
            })
          },
          submitHHxm(rd){
              var subflag4 = false;
              this.$refs['form4'].validate((valid) => {
                  if (valid){
                      subflag4=true;
                  }else{
                      this.$msg.msge("请完善合同信息后再提交！");
                      return false;
                  }
              });
              if (!subflag4) {
                  return;
              }
              if ('0' == this.formInline.status){
                this.$alert("合同已审批通过，是否再次发起审批？",'提示',{
                  showCancelButton: true,
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  callback: (action) => {
                    console.log(action)
                    if (action === 'confirm') {
                      var citys = this.formInline.salesCity;
                      this.formInline.salesCity = citys.join(",");
                      this.formInline.isZc = rd;
                      this.formInline.status = 0;
                      ss.contractService.insertHhxm(this.formInline).then(rd=>{
                        if(rd.f){
                          if (1 == this.formInline.isZc){
                            this.$msg.msgs("暂存成功！");
                          }else if (0 == this.formInline.isZc){
                            this.$msg.msgs("提交成功！");
                          }
                          this.$router.push("contract-list").then(() => {
                            window.location.reload()
                          });
                        }else{
                          this.$msg.msgs("提交失败！"+rd.msg);
                        }
                      })
                    }
                  }
                })
              }else {
                var citys = this.formInline.salesCity;
                this.formInline.salesCity = citys.join(",");
                this.formInline.isZc = rd;
                this.formInline.status = 0;
                ss.contractService.insertHhxm(this.formInline).then(rd=>{
                  if(rd.f){
                    if (1 == this.formInline.isZc){
                      this.$msg.msgs("暂存成功！");
                    }else if (0 == this.formInline.isZc){
                      this.$msg.msgs("提交成功！");
                    }
                    this.$router.push("contract-list").then(() => {
                      window.location.reload()
                    });
                  }else{
                    this.$msg.msgs("提交失败！"+rd.msg);
                  }
                })
              }

          },
          getCityChange(value){
              this.citys = value.join(",")
          },
          isEmpty(attr) {
            if (attr == null || attr == "") {
              return true;
            } else {
              return false;
            }
          },
          isNotEmpty(attr) {
            if (attr != null && attr != "") {
              return true;
            } else {
              return false;
            }
          },
          changeCatogory(attr){

          },
          formatDate(date){
            if (this.isNotEmpty(date)) {
              function addDateZero(num) {
                return (num < 10 ? "0" + num : num);
              }
              let d = new Date(date);
              let format = d.getFullYear()+"-"+addDateZero(d.getMonth()+1)+"-"+addDateZero(d.getDate());
              return format;
            }
          },
          daquPass(query){
            this.formInline.aaa = query;
            ss.contractService.daquPass(this.formInline).then(rd=>{
              this.$msg.alerts("提交成功！", () => {
                //刷新右上角的代办个数
                this.$store.dispatch("searchTasktotal")
                //跳转回系统的代办列表
                this.$router.push({
                  path: '/personal/dealCenter'
                })
              })
            })
          },
        contractPass(query){
          this.formInline.aaa = query;
          this.formInline.taskid = this.taskid;
          var citys = this.formInline.salesCity;
          this.formInline.salesCity = citys.join(",");
          ss.contractService.hhContractPass(this.formInline).then(rd=>{
            this.$msg.alerts("提交成功！", () => {
              //刷新右上角的代办个数
              this.$store.dispatch("searchTasktotal")
              //跳转回系统的代办列表
              this.$router.push({
                path: '/personal/dealCenter'
              })
            })
          })
        },

        //查询渠道
        selectChannel() {
          ss.Dictservice.listbycategory("sales_region").then(response => {
            this.qudao = response;
          })
        },
        lianqunOptions(value){
          console.log("value",value);
          var jsonObj = value
          var jStr = '';
          for(var item in jsonObj){
            jStr += jsonObj[item]+",";
          }
          this.formInline.lianqun = jStr.substring(0, jStr.lastIndexOf(','))
          console.log(this.formInline.lianqun);
        },
        getQudao(value){
          console.log(value);
          var jsonObj = value
          var jStr = '';
          for(var item in jsonObj){
            jStr += jsonObj[item]+",";
          }
          this.channels = jStr.substring(0, jStr.lastIndexOf(','))
        },
        getLianquns(s){
          var m  = s.split(',');
          if(m.length<=0){
            this.lianqunList = ''
          }else {
            this.lianqunList = m
          }
          if(this.formInline.lianqun.includes("X02") || this.formInline.lianqun.includes("X01")
              || this.formInline.lianqun.includes("X08") || this.formInline.lianqun.includes("X09") || this.formInline.lianqun.includes("X10")
              || this.formInline.lianqun.includes("X05") || this.formInline.lianqun.includes("X06")
          ){
            this.isCt = true;
          }else {
            this.isCt = false;
          }
        },
			// 关闭新手引导页
			closeIt(){
				this.showOrhide = false;
				if(this.checked){
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}else{
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}
			},
        fillCusCode(){
          this.formInline.customerCode = this.formInline.customerName;
        },
			nextStep(i){
				if(this.status ==1){
						this.status = 2;
				}else if(this.status ==2){
					if(this.checked){
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}else{
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}
				}
			},
			// 时间戳转换日期
			timestampToTime(timestamp) {
			  var  date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
			  let Y = date.getFullYear() ;
			  let M = (date.getMonth()+1 < 10 ?  '0' +(date.getMonth()+1) : date.getMonth()+1) ;
			  let D = date.getDate().toString().padStart(2,0);
			  let h = date.getHours() +  ':' ;
			  let m = date.getMinutes() +  ':' ;
			  let s = date.getSeconds();
			  return  Y + '-' + M + '-' + D;//+h+m+s
			},
			/**
			 * 查询当天日期
			 */
			// getNowDate(d) {
			//   const timeOne = new Date()
			//   const year = timeOne.getFullYear()
			//   let month = timeOne.getMonth() + 1
			//   let day = timeOne.getDate()
			//   month = month < 10 ? '0' + month : month
			//   day = day < 10 ? '0' + day : day
			//   const NOW_MONTHS_AGO = `${year}-${month}-${day}`
			//   return NOW_MONTHS_AGO
			// },
			stRentTime(){
			  let that = this;
			  that.formInline.contractStarttime = that.timestampToTime(new Date().getTime());// 默认开始日期
			  that.formInline.contractEndtime = that.timestampToTime(new Date().getTime()+that.formInline.rentTime*24*60*60*1000);// 默认结束日期
				for(var i = 0;i < this.rentTimeList.length;i++){
					var priceData = this.rentTimeList[i];
					if(priceData.rentTerm == this.formInline.rentTime){
						that.formInline.rentPrice = priceData.rentPrice;
						if(this.formInline.zlList){
							for(var j = 0;j < this.formInline.zlList.length;j++){
								var zl = this.formInline.zlList[j];
								if(zl.priceType == 'ZL01'){
									zl.productUnitPrice = priceData.rentPrice;
								}
							}
						}
					}
				}
			},
			setZlDate(){
				let that = this;
				var newDate = new Date(that.formInline.contractStarttime);
				that.formInline.contractEndtime = that.timestampToTime(newDate.getTime()+that.formInline.rentTime*24*60*60*1000-24*60*60*1000);// 默认结束日期
			},
          setAddDate(index){
              let that = this;
              var newDate = new Date(that.contarctAddList[index].starttime);
              that.contarctAddList[index].endtime = that.timestampToTime(newDate.getTime()+that.formInline.rentTime*24*60*60*1000-24*60*60*1000);// 默认结束日期
          },
        cancel(){
          this.$router.push("contract-list");
        },
        getCity(s){
          var s1 = s;
          var m  = s1.split(',');
          if(m.length<=0){
            this.formInline.salesCity = ''
          }else {
            this.formInline.salesCity = m
          }
        },
        getAreaCity(){
          let areas = this.formInline.saleareaCode.split(",");
          let ss1 = [];
          let promises = []; // 创建一个存储异步操作的Promise数组
          for (var i = 0; i < areas.length; i++) {
            let promise = ss.Dictservice.getDictByCateCode("YlSalesArea_chanpin", areas[i])
                .then(response => {
                  ss1.push(response.refid);
                });
            promises.push(promise); // 将每个异步操作的Promise添加到数组中
          }

          Promise.all(promises) // 等待所有异步操作完成
              .then(() => {
                var s2 = ss1.join(",");
                ss.UserService.getCityByArea(s2).then(rd => {
                  this.salesCity = rd.msg;
                });
              });
        },
          //框架合同table页
          tabchange(i) {
              console.log(i);
              this.tabIndex = i;
              if (this.tabIndex == '1') {
                  this.tabflag = true;
              } else if (this.tabIndex == '3') {
                  this.tabflag = true;
              } else if (this.tabIndex == '2') {
                  this.tabflag = true;
              }
          },
          selectPageAll() {
              this.q2.agentName = this.formInline.customerCode;
              this.q2.contractId = this.formInline.id;
              ss.grabOrderApi.selectPageTargetAgainstUser(this.q2).then(res => {
                  console.log(res)
                  console.log("total", res.total)
                  this.tableData2 = res.records
                  this.q2.total = res.total
                  console.log("table", this.tableData2)
              })
          },
          queryMb() {
                this.q3.agentNameLike = this.formInline.customerName;
              this.q3.salesRegionCode = this.formInline.salechannelCode;
              ss.fanli.pagefanliXsjl(this.q3).then(rd=>{
                  this.q3.total = rd.total;
                  this.tableData3 = rd.records;
              });

          },
          getContarctSon(v){
              ss.contractService.getContractSon(v).then(rd => {
                  this.contractSonList = rd.msg;
              })
          },
          checkSon(id){
              this.$router.push({path:"/contract-agent-see", query:{key: id}})
          },
          addXyList(){
              this.contarctAddList.push({
                  id:null,
                  contractId:null,
                  type:null,
                  starttime:null,
                  endtime:null,
                  status:null,
                  instid:null,
                  refid:this.$util.getUuid(),
              })
          },
          deleteXyList(){
              if(this.contarctAddList.length != 1){
                  this.contarctAddList.splice(this.contarctAddList.length-1, 1)
              }
          },
          submitAgentAdd(){
              this.$msg.confirm("确定要提交吗？",()=>{
                  this.contarctAdd.contarctAddLists = this.contarctAddList;
                  this.contarctAdd.contractId = this.formInline.id;
                  this.contarctAdd.saleareaCode = this.formInline.saleareaCode;
                  ss.contractService.insertAgentAdd(this.contarctAdd).then(rd=>{
                      if(rd.f){
                          this.$msg.msgs("提交成功！");
                          this.$router.push("contract-list");
                      }else{
                          this.$msg.msgs("提交失败！"+rd.msg);
                      }
                  })
              })
          },
		},
      mounted() {
            this.contractId = this.$route.query.key;
            this.updateContract = this.$route.query.updateContract;
            if (this.contractId != null) {
                if(this.updateContract == 1){
                    this.disabled = false;
                }else {
                    this.disabled = true;
                }
              ss.contractService.detail(this.contractId).then(rd=>{
                this.guanlianxiangmFlag = false;
                this.formInline = rd.obj;
                this.formInline.id = this.contractId;
                if(this.formInline.salesCity != null && this.formInline.salesCity){
                  let s = this.formInline.salesCity;
                  this.getCity(s);
                  this.getAreaCity();
                }
              })
            }
      },
      created() {
        this.instid = this.$route.query.instid;
        this.isXy = this.$route.query.isXy;
         this.taskid = this.$route.query.taskid;
        this.selectChannel();
        this.tabIndex = '1';
        if(null != this.instid && this.instid != ''){
          this.disabled = true;
          //根据instid查询数据
            ss.contractService.getContractByInstid(this.instid).then(rd => {
                console.log('rdrdrd',rd)
                if(rd.f){
                    this.formInline = rd.msg;
                    this.contractId = this.formInline.id;
                    if(this.formInline.salesCity != null && this.formInline.salesCity != ''){
                        let s = this.formInline.salesCity;
                        this.getCity(s);
                        this.getAreaCity();
                    }
                }
            })
        }
      }
    }
</script>

<style>
/* .h-formbLine .el-form-item__label{
	width: 18%;
} */
.yearIcon .el-input:after {
  content: '天';
  font-size: 0.18rem;
  color: #b8b6b6;
  /* font-weight: bold; */
  position: absolute;
  right: 0.15rem;
}
.weekplandetail1 .h-formbLine .el-form-item__label{
	width: 11%;
	text-align: right;
}
.weekplandetail23 .h-formbLine .el-form-item__label{
	width: 34%;
	text-align: right;
}
.weekplandetail23 .h-formbLine .el-form-item__content{
	width: 66%;
}
.weekplandetail23 .h-formbLine .h-elformWrap-2{
	width: 33.333%;
	padding-right: 0.5rem
}
.weekplandetail23 .h-formbLine .h-elformWrap-1{
	width: 100%;
	padding-right: 0.5rem
}
.weekplandetail23 .h-formbLine .h-elformWrap-1 .el-form-item__label{
	width: 10.4%;
}
.weekplandetail23 .h-formbLine .h-elformWrap-1 .el-form-item__content{
	width: 89.6%;
}
.ljjtips .el-table tbody td .cell{
	padding: 0.2rem 0.1rem;
}
.outerCon {
    display: flex;
    justify-content: flex-start;
    border-bottom: 1px solid #dae0f0;
    width: 100%;
    margin-bottom: 30px;


.tabBtn {
    background-color: #f0f5fb;
    padding: 10px;
    border: 1px solid #dae0f0;
    margin-right: 10px;
    color: #282c2f;
    cursor: pointer;
}

.tabBtnAc {
    color: white;
    background-color: #2785e7;
}
.foundation-box{
    font-size: 0.18rem;
    color: #868686;
    line-height: 0.28rem;
}
.signsign .h-formbLine .el-form-item__label {
    width: 39%;
}

.zhanghu .h-formbLine .el-form-item__content,
.signsign .h-formbLine .el-form-item__content {
    width: 52%;
}

.zhanghu .h-formbLine .h-elformWrap-2,
.signsign .h-formbLine .h-elformWrap-2 {
    width: 25%;
    padding-right:0
}

}
</style>
<style scoped lang="scss">
    .bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
    .leaderBox{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;
		.leaderbg{
			width: 100%;
			height: 100%;
		}
		.steps{
			position: absolute;
			z-index: 1;
		}
		.step1{
			top: 2.6rem;
			left: 3.15rem;
			width: 4rem;
			height: 1.7rem;
		}
		.step2{
			top: 4.55rem;
			left: 3.9rem;
			width: 13.5rem;
			height: 2.3rem;
		}

		.stepbtn{
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0,0,0,0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.65rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}
		.closeIt{
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
		}
	}
</style>
